(() => {
  'use strict';
  const dialog = document.getElementById('nc-support-popup');
  if (!dialog || dialog.dataset.ready || typeof dialog.showModal !== 'function') return;
  dialog.dataset.ready = 'true';

  const capKey = 'noclen-support-until-v1';
  const intentKey = 'noclen-support-buying-v1';
  const day = 86400000;
  const buySelector = '#noclen-buy, #nc-sticky, product-form, form[action*="/cart/add"], [name="add"], a[href*="#noclen-buy"], a[href*="/cart"], a[href*="/checkout"]';
  let stopped = false;
  let shown = false;
  let opener = null;
  let elapsed = 0;
  let visibleSince = document.hidden ? null : performance.now();
  let timer = null;
  let quietTimer = null;
  let lastInteraction = performance.now();
  let savedOverflow = '';
  let savedGutter = '';

  const read = (store, key) => {
    try { return window[store].getItem(key); } catch (_) { return null; }
  };
  const write = (store, key, value) => {
    try { window[store].setItem(key, String(value)); } catch (_) { /* Private mode: page-local cap still applies. */ }
  };
  const cap = (days) => write('localStorage', capKey, Math.max(Number(read('localStorage', capKey)) || 0, Date.now() + days * day));
  const visible = (el) => {
    if (!el || !el.getClientRects().length) return false;
    if (el.closest('details:not([open]), [hidden], [aria-hidden="true"]')) return false;
    for (let node = el; node instanceof Element; node = node.parentElement) {
      const style = window.getComputedStyle(node);
      if (style.visibility === 'hidden' || style.display === 'none' || style.opacity === '0') return false;
    }
    const rect = el.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
  };
  const overlayOpen = () => [...document.querySelectorAll('dialog[open], [role="dialog"], cart-drawer.active, cart-notification.active, details[open].menu-drawer-container, .shopify-pc__banner__dialog')]
    .some(el => el !== dialog && visible(el));
  const typing = () => document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
  const inBuy = () => [...document.querySelectorAll('#noclen-buy, product-form, form[action*="/cart/add"]')].some(visible);

  function stopAutomatic() {
    stopped = true;
    clearTimeout(timer);
    clearTimeout(quietTimer);
  }
  function open(manual) {
    if (dialog.open || overlayOpen() || (!manual && (stopped || document.hidden || typing() || inBuy()))) return;
    opener = document.activeElement;
    savedOverflow = document.documentElement.style.overflow;
    savedGutter = document.documentElement.style.scrollbarGutter;
    document.documentElement.style.scrollbarGutter = 'stable';
    document.documentElement.style.overflow = 'hidden';
    dialog.showModal(); // Native focus containment, background inertness and Escape support.
    dialog.querySelector('[data-nc-support-close]').focus({ preventScroll: true });
    shown = true;
    cap(7);
    stopAutomatic();
  }
  function close() {
    if (dialog.open) dialog.close();
  }
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = savedOverflow;
    document.documentElement.style.scrollbarGutter = savedGutter;
    if (opener && opener !== document.body && opener.isConnected) opener.focus({ preventScroll: true });
  });
  dialog.addEventListener('click', (event) => {
    if (event.target.closest('[data-nc-support-close]')) close();
    const claim = event.target.closest('[data-nc-support-claim]');
    if (claim) {
      if (!window.NoclenContact) return;
      cap(90);
      dialog.addEventListener('close', () => window.NoclenContact.open(claim.dataset.ncSupportIntent || 'support-group'), {once:true});
      close();
    }
    // A click on the backdrop has the dialog as its target, outside its bounds.
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    }
  });
  // Manual CTAs are handled by the shared NoclenContact controller.
  document.addEventListener('noclen:contact-open', stopAutomatic);

  function buying(event) {
    if (!event.target.closest || !event.target.closest(buySelector)) return;
    write('sessionStorage', intentKey, '1');
    stopAutomatic();
  }
  document.addEventListener('pointerdown', buying, { passive: true });
  document.addEventListener('focusin', buying);
  document.addEventListener('submit', buying);
  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' || event.key === ' ') buying(event);
  });

  // Manual footer/contact triggers remain available on every page. Automatic
  // invitation is homepage-only, only with an empty cart, and never in the editor.
  if (dialog.dataset.ncSupportAuto !== 'true' || window.Shopify?.designMode || Number(read('localStorage', capKey)) > Date.now() || read('sessionStorage', intentKey)) return;

  function tryAutomatic() {
    if (stopped || shown || document.hidden) return;
    const activeTime = elapsed + (visibleSince === null ? 0 : performance.now() - visibleSince);
    if (activeTime < 45000) {
      clearTimeout(timer);
      timer = setTimeout(tryAutomatic, 45000 - activeTime);
      return;
    }
    const scrollRange = document.documentElement.scrollHeight - window.innerHeight;
    if (window.scrollY < Math.max(600, scrollRange * .25)) return;
    // Wait until scrolling/tapping settles instead of interrupting an action.
    if (performance.now() - lastInteraction < 1800) {
      clearTimeout(quietTimer);
      quietTimer = setTimeout(tryAutomatic, 1900);
      return;
    }
    open(false);
  }
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      if (visibleSince !== null) elapsed += performance.now() - visibleSince;
      visibleSince = null;
      clearTimeout(timer);
    } else {
      visibleSince = performance.now();
      tryAutomatic();
    }
  });
  const onInteraction = () => {
    if (stopped) return;
    lastInteraction = performance.now();
    clearTimeout(quietTimer);
    quietTimer = setTimeout(tryAutomatic, 1900);
  };
  window.addEventListener('scroll', onInteraction, { passive: true });
  document.addEventListener('pointerdown', onInteraction, { passive: true });
  document.addEventListener('keydown', onInteraction);
  tryAutomatic();
})();
